export default "__VITE_ASSET__Bvw2wMX___"